import {basename} from 'node:path';
import {Readable} from 'node:stream';
import {pipeline} from 'node:stream/promises';

import retry from 'async-retry';
import chalk from 'chalk';
import ora from 'ora';
import tar from 'tar';

/**
 * Fetch a tarball stream from the given URL.
 */
async function fetchTarStream(url: string): Promise<Readable> {
  const res = await fetch(url);

  if (!res.ok || !res.body) {
    throw new Error(`Failed to fetch tarball: ${res.status} ${res.statusText}`);
  }

  // Convert Web stream to Node Readable
  return Readable.fromWeb(res.body);
}

/**
 * Download and extract a template tarball to the given directory.
 */
export async function downloadTemplate(root: string, url: string): Promise<void> {
  const spinner = ora(`Downloading template from ${basename(url)}...`).start();

  try {
    await retry(
      async (bail) => {
        try {
          await pipeline(
            await fetchTarStream(url),
            tar.x({
              cwd: root,
              strip: 1 // remove top-level folder
            })
          );
        } catch (err) {
          bail(new Error(`Failed to download ${url}: ${err instanceof Error ? err.message : err}`));
        }
      },
      {
        minTimeout: 500,
        retries: 3
      }
    );

    spinner.succeed(chalk.green(`Template downloaded to ${root}`));
  } catch (err) {
    spinner.fail(
      chalk.red(`Failed to download template: ${err instanceof Error ? err.message : err}`)
    );
    throw err;
  }
}
